import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";
import { AppShell } from "@/components/AppShell";
import { Alert } from "@/components/ui/Alert";
import { Spinner } from "@/components/ui/Spinner";
import { useSettingsAcl } from "./lib/useSettingsAcl";

interface TopicNavItem {
  to: string;
  label: string;
  visible: (acl: ReturnType<typeof useSettingsAcl>) => boolean;
}

const TOPIC_NAV: TopicNavItem[] = [
  { to: "stammdaten", label: "Stammdaten", visible: (a) => a.canAuftraege },
  { to: "hero", label: "Hero", visible: (a) => a.canAuftraege },
  { to: "vorlagen", label: "Vorlagen", visible: (a) => a.canAuftraege || a.canBestellungen },
  { to: "dokumente", label: "Dokumente", visible: (a) => a.canAuftraege },
  { to: "status-sichtbarkeit", label: "Status-Sichtbarkeit", visible: (a) => a.canAuftraege },
  { to: "kommunikation", label: "Kommunikation", visible: () => true },
  { to: "tagesgeschaeft", label: "Tagesgeschäft", visible: (a) => a.canAuftraege },
  { to: "druck", label: "Druck", visible: (a) => a.canAuftraege },
  { to: "sitzungen", label: "Sitzungen", visible: (a) => a.canSessions },
];

export function SettingsLayout() {
  const acl = useSettingsAcl();
  const visibleNav = TOPIC_NAV.filter((item) => !acl.loading && item.visible(acl));

  return (
    <AppShell
      title="Einstellungen"
      subtitle="Ordner, Kunden, Hero-Konfiguration, Vorlagen und weitere Stammdaten."
      back={{ to: "/admin", label: "zurück zum Admin-Hub" }}
    >
      {acl.loading ? (
        <div className="flex items-center gap-2 text-sm text-label-secondary">
          <Spinner /> Berechtigungen werden geprüft …
        </div>
      ) : (
        <>
          {visibleNav.length > 0 && (
            <nav
              className="flex flex-wrap gap-2 border-b border-separator pb-4"
              aria-label="Einstellungs-Themen"
            >
              <NavLink
                to="/admin/einstellungen"
                end
                className={({ isActive }) =>
                  clsx(
                    "rounded-full px-3 py-1.5 text-sm font-medium transition",
                    isActive
                      ? "bg-accent text-white"
                      : "bg-fill-tertiary text-label-secondary hover:bg-fill-secondary hover:text-label",
                  )
                }
              >
                Übersicht
              </NavLink>
              {visibleNav.map((item) => (
                <NavLink
                  key={item.to}
                  to={`/admin/einstellungen/${item.to}`}
                  className={({ isActive }) =>
                    clsx(
                      "rounded-full px-3 py-1.5 text-sm font-medium transition",
                      isActive
                        ? "bg-accent text-white"
                        : "bg-fill-tertiary text-label-secondary hover:bg-fill-secondary hover:text-label",
                    )
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          )}
          <Outlet context={acl} />
        </>
      )}
    </AppShell>
  );
}

export function SettingsAccessDenied() {
  return (
    <Alert variant="warning" title="Keine Berechtigung">
      Für diesen Bereich fehlt die erforderliche Berechtigung.
    </Alert>
  );
}
